import fp from 'lodash/fp'
import {
  combine,
  withRef,
  withState,
  withLayoutEffect,
} from 'react-hooks-combine'

import ContentLoader from './component'

export default combine({
  defaultProps: {
    onlyOverlay: false,
    fixed: false,
  },

  hooks: [
    withRef('timeoutTokenRef'),
    withState('waiting', 'wait', (_state, { delay, loading }) => {
      return fp.isUndefined(delay) && loading
    }),
    withLayoutEffect(
      ({ timeoutTokenRef, wait }, { loading, delay }) => {
        if (timeoutTokenRef.current) {
          clearTimeout(timeoutTokenRef.current)
        }

        if (fp.isNumber(delay) && loading) {
          timeoutTokenRef.current = setTimeout(() => {
            wait(loading)
          }, delay)
        } else {
          wait(loading)
        }
      },
      ['loading', 'waiting', 'children']
    ),
  ],
})(ContentLoader)
